<span *ngIf="accessEnable">
<div class="alert alert-danger alert-dismissible " *ngIf="errorMessage !== ''" role="alert">
  {{errorMessage}}<mat-icon class="close-icon" (click)="closeAlert()">close</mat-icon>
</div>
<div class="alert alert-success alert-dismissible " *ngIf="successMessage !== ''" role="alert">
  {{successMessage}}<mat-icon class="close-icon" (click)="closeAlert()">close</mat-icon>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">{{spinnerMessage}}</p>
</ngx-spinner>

<!-- UPLOAD SECTION -->
<ng-container>
<mat-accordion class="example-headers-align">
  <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <strong>Upload File</strong>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="alert alert-info" *ngIf="selectedUploadType && hasTemplate(selectedUploadType) && !selectedFile" role="alert" style="margin-bottom:10px;">
      <mat-icon style="vertical-align:middle;margin-right:6px;font-size:18px;">info</mat-icon>
      Please download the template file before uploading to ensure your data is in the correct format and avoid errors.
    </div>

    <div class="upload-row">
      <div class="upload-fields">
        <mat-form-field>
          <mat-label>Upload Type</mat-label>
          <mat-select [typeaheadDebounceInterval]="500" [(ngModel)]="selectedUploadType" name="selectedUploadType">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let t of uploadTypes" [value]="t.id">{{t.label}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="file-field">
          <mat-label>Selected File</mat-label>
          <input matInput readonly [value]="selectedFileName || ''">
          <button mat-icon-button matSuffix (click)="fileInput.click()" type="button">
            <mat-icon>attach_file</mat-icon>
          </button>
          <input type="file" #fileInput style="display:none" (change)="onFileSelected($event)" accept=".csv,.xlsx,.xls" />
        </mat-form-field>
      </div>

      <div class="upload-actions">
        <button mat-button (click)="onUpload()" [disabled]="!selectedUploadType || !selectedFile || !canUploadSelectedType()">Upload</button>
        <button mat-button (click)="onDownloadTemplate()" [disabled]="!selectedUploadType || !hasTemplate(selectedUploadType)">Download Template</button>
        <button mat-button (click)="resetUpload()">Reset</button>
      </div>
    </div>

    <div *ngIf="selectedUploadType && getSelectedUploadStatus() && !canUploadSelectedType()" class="upload-status-info">
      Current Status: <span [ngClass]="{
        'status-started':    getSelectedUploadStatus() === 'STARTED',
        'status-initiated':  getSelectedUploadStatus() === 'INITIATED',
        'status-inprogress': getSelectedUploadStatus() === 'IN_PROGRESS',
        'status-error':      getSelectedUploadStatus() === 'ERROR'
      }">{{ getSelectedUploadStatus() }}</span>
        &nbsp;— Upload blocked until status is COMPLETED or ERROR
    </div>

    <div class="file-hint">Supported formats: .xlsx, .xls, .csv | Max size: 10 MB</div>

  </mat-expansion-panel>
</mat-accordion>

<!-- DOWNLOAD SECTION -->
<mat-accordion class="example-headers-align">
  <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <strong>Download Report</strong>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="upload-row">
      <div class="upload-fields">
        <mat-form-field>
          <mat-label>Report Type</mat-label>
          <mat-select [typeaheadDebounceInterval]="500" [(ngModel)]="selectedDownloadType" name="selectedDownloadType" (selectionChange)="onDownloadTypeChange()">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let t of downloadTypes" [value]="t.id">{{t.label}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="upload-actions">
        <button mat-button (click)="onDownload()" [disabled]="!selectedDownloadType || !selectedS3File">Download</button>
        <button mat-button (click)="resetDownload()">Reset</button>
      </div>
    </div>

    <!-- S3 Files Grid -->
    <div *ngIf="selectedDownloadType && s3Files.length > 0" class="grid-container">
      <ngx-datatable #s3Table class="material striped" [rows]="s3Files"
        [columnMode]="ColumnMode.force" [headerHeight]="45" [footerHeight]="false"
        rowHeight="30" [limit]="limitSelected" [selected]="selectedS3FileRows"
        [selectionType]="SelectionType.single" [selectAllRowsOnPage]="false"
        (select)="onS3FileSelect($event)"
        [ngClass]="{'hideerror': s3Files.length > 0, 'showerror': s3Files.length === 0}">

        <ngx-datatable-column [width]="65" [sortable]="false" [canAutoResize]="false" [draggable]="false"
          [resizeable]="false" [headerCheckboxable]="true" [checkboxable]="true" name="Select">
        </ngx-datatable-column>
        <ngx-datatable-column name="File Name" prop="fileName"></ngx-datatable-column>
        <ngx-datatable-column name="Last Modified" prop="lastModified">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.lastModified | date:'yyyy-MM-dd HH:mm:ss'}}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Size" prop="size"></ngx-datatable-column>
      </ngx-datatable>
    </div>

    <div *ngIf="selectedDownloadType && loadingS3Files" class="loading-message">
      <mat-spinner diameter="30"></mat-spinner>
      <span>Loading files from S3...</span>
    </div>

    <div *ngIf="selectedDownloadType && !loadingS3Files && s3Files.length === 0" class="no-files-message">
      No files available for download.
    </div>

  </mat-expansion-panel>
</mat-accordion>
</ng-container>
</span>

